import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { Typography, Card } from "antd";
import { MinusOutlined } from "@ant-design/icons";
import { parse } from 'date-fns';


function Order(props) {
    const { data } = props;
    const { Title, Paragraph } = Typography;

    const [dataOrder, setDataOrder] = useState(data?.graph_total_order);


    useEffect(() => {
        setDataOrder(data?.graph_total_order);

    }, [data]);

    const lineChart = {
        series: [
            {
                name: "Orders",
                data: dataOrder?.data,
                offsetY: 0,
            },
        ],

        options: {
            chart: {
                width: "100%",
                height: 350,
                type: "area",
                toolbar: {
                    show: false,
                },
            },

            legend: {
                show: false,
            },

            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },

            yaxis: {
                labels: {
                    style: {
                        fontSize: "14px",
                        fontWeight: 600,
                        colors: ["#8c8c8c"],
                    },
                    formatter: function (val) {
                        return parseInt(val)
                    },
                },
            },

            xaxis: {
                labels: {
                    style: {
                        fontSize: "14px",
                        fontWeight: 600,
                        colors: "#8c8c8c",
                    },
                },
                categories: dataOrder?.labels,
            },

            tooltip: {
                y: {
                    formatter: function (val) {
                        return parseInt(val)
                    },
                },
            },
        },
    };


    return (
        <div>
            <Card>
                <div className="linechart">
                    <div>
                        <Title level={5}>Orders</Title>
                        <Paragraph className="lastweek">
                            than last week <span className="bnb2">-%</span>
                        </Paragraph>
                    </div>
                </div>

                <ReactApexChart
                    className="full-width"
                    options={lineChart.options}
                    series={lineChart.series}
                    type="area"
                    height={350}
                    width={"100%"}
                />

                <div className='grid grid-cols-4 gap-4 p-4'>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{data?.average_overview?.averagePerDay?.toFixed(2)}</h1>
                        <p className="text-sm">Avg. Order/day</p>
                    </div>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{data?.average_overview?.averagePerWeek?.toFixed(2)}</h1>
                        <p className="text-sm">Avg. Order/week</p>
                    </div>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{data?.average_overview?.averageItemsPerOrder?.toFixed(2)}</h1>
                        <p className="text-sm">Avg. Item/Order</p>
                    </div>
                    <div className='col-span-1 flex justify-center flex-col items-center'>
                        <h1 className="font-bold text-lg">{data?.average_overview?.averageServicePerOrder?.toFixed(2)}</h1>
                        <p className="text-sm">Avg. Service/Order</p>
                    </div>
                </div>
            </Card>
        </div>
    );
}

export default Order;